<template>
  <div class="bg-white citys-box">
    <div>
      <div>热门城市</div>
      <div class="flex flex-wrap  ">
        <div class="mg-r-20" v-for="(el, i) of list[0].children" @click="select(el)" :key="i">
          <span>{{ el.name }}</span>
        </div>
      </div>
    </div>
    <div v-for="(el, i) of list.filter((it, idx) => idx > 0)" :key="i">
      <div>{{ el.name }}</div>
      <div class="">
        <div class="mg-r-10" v-for="(it, idx) of el.children" :key="idx">
          <span>{{ it.name }}</span>
          <div class="flex flex-wrap full-w">
            <div class="mg-r-20" v-for="(item, index) of it.children" @click="select(item)" :key="index">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: '热门城市',
          children: [
            { name: '北京', id: '1' },
            { name: '上海', id: '2' },
            { name: '广州', id: '3' },
            { name: '深圳', id: '4' },
            { name: '成都', id: '5' },
          ],
        },
        {
          name: '国内城市',
          children: [
            {
              name: 'A',
              children: [
                { name: '安徽', id: '1' },
                { name: '安庆', id: '2' },
                { name: '合肥', id: '3' },
                { name: '马鞍山', id: '4' },
                { name: '芜湖', id: '5' },
              ],
            },
            {
              name: 'B',
              children: [
                { name: '安徽', id: '1' },
                { name: '安庆', id: '2' },
                { name: '合肥', id: '3' },
                { name: '马鞍山', id: '4' },
                { name: '芜湖', id: '5' },
              ],
            },
          ],
        },
      ],
    }
  },
  methods:{
    select(it){
        this.$emit('onSelect',it)
    }
  }
}
</script>

<style lang="less" scoped>
.citys-box {
  width: 430px;
  padding: 10px;
}
</style>
